import {
  useMutation,
  type QueryKey,
  type UseMutationOptions,
  type UseMutationResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { api } from '@/utils/api';
import { ApiErrorResponse, ApiResponse } from '@/types/api';

export interface DeleteFileClientRequest {
  fileId: number;
  clientId: number;
}

export const deleteFileClient = ({
  fileId,
  clientId,
}: DeleteFileClientRequest) => {
  return api.delete<ApiResponse<undefined>>('/file/client', {
    params: {
      fileId,
      clientId,
    },
  });
};

const useDeleteFileClient = <TError = AxiosError<ApiErrorResponse>>(
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse<undefined>>,
    TError,
    DeleteFileClientRequest,
    QueryKey
  >,
): UseMutationResult<
  AxiosResponse<ApiResponse<undefined>>,
  TError,
  DeleteFileClientRequest,
  QueryKey
> => {
  return useMutation(deleteFileClient, {
    ...options,
  });
};

export default useDeleteFileClient;
